import { Select as SelectPrimitive } from '@base-ui/react/select';
import type { ComponentProps } from 'react';

import ChevronDownIcon from '@/assets/svg/chevron-down.svg?react';
import { cn } from '@/lib/utils';

export type SelectScrollDownButtonProps = ComponentProps<typeof SelectPrimitive.ScrollDownArrow>;

const SelectScrollDownButton = ({ className, ...props }: SelectScrollDownButtonProps) => {
  return (
    <SelectPrimitive.ScrollDownArrow
      data-slot="select-scroll-down-button"
      className={cn(
        'top-0 z-10 flex w-full cursor-default items-center justify-center bg-white py-1',
        '[&_svg:not([class*="size-"])]:size-4',
        className,
      )}
      {...props}
    >
      <ChevronDownIcon className="size-4" />
    </SelectPrimitive.ScrollDownArrow>
  );
};

export default SelectScrollDownButton;
